import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectState = (state) => state.get('formsPage') || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));

export const selectError = createSelector(selectState, (state) => state.get('error'));
